import {API} from '../../api/API';
import { BUSINESS_REGISTRATION_RESET_PASSWORD_URL} from '../../config/config';


export const resetPassword = async (resetPasswordInputData) => {   
    let response = await API.put(BUSINESS_REGISTRATION_RESET_PASSWORD_URL.replace('${userId}',resetPasswordInputData.userId), resetPasswordInputData);
    if (response.status===200) {
        response.data={'success':true,
        'message':'Password changed successfully'};
    }
    return response.data;
}